import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, hasRole } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center text-[#7A7873]" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !hasRole(...roles))
    return (
      <div className="p-12 text-center" data-testid="no-permission">
        <h2 className="text-2xl font-heading font-bold mb-2">Access denied</h2>
        <p className="text-[#7A7873]">You don't have permission to view this page.</p>
      </div>
    );
  return children;
}
